import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import 'LIBS/jquery.showhtml.js';
import 'LIBS/jquery.placeholder.js';

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";
import 'HSNDIR/Template/EmailCaptureCommon.js';

/**
* class HSN.EmailCaptureModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.EmailCaptureModal = (function (parent) {
    __extends(EmailCaptureModal, parent);

    function EmailCaptureModal(config) {
        var modal = EmailCaptureModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own

        this.template = HSN.Template.EmailCaptureCommon.prototype;

        eventHandlers(this);

        return modal;
    }

    template: null;

    function eventHandlers(modal) {

        $(modal.Content).on('paste', '#capture-email-address-again', function () {
            return false;
        });

        $(modal.Content).on('keyup', '#capture-email-address-again', function () {
            var $this = $(this);
            if ($this.val() !== $('#capture-email-address').val()) {
                $this.addClass('invalid-email');
            } else {
                $this.removeClass('invalid-email');
            }
        });

        $(modal.Content).on('keyup', '#capture-email-address', function () {
            var $this = $(this);
            if (!HSN.ValidateEmail($('#capture-email-address').val())) {
                $this.addClass('invalid-email');
            } else {
                $this.removeClass('invalid-email');
            }
        });

        $(modal.Content).on('click', '#capture-signup', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var emailAddress = $('#capture-email-address').val();
            var emailAddressAgain = $('#capture-email-address-again').val();

            if(emailAddress === '' || emailAddress === null || !HSN.ValidateEmail(emailAddress)) {
                $('#capture-error').html('Please enter an email address.');
                $('#capture-email-address').addClass('invalid-email');
                return;
            }

            if (emailAddress !== emailAddressAgain) {
                $('#capture-error').html('Your email and confirm email do not match.');
                $('#capture-email-address-again').each(function () {
                    $(this).addClass('invalid-email');
                });
                return;
            }

            HSN.DataLayer.helpers.metricEvent(null, 'RE:emailsignup', 'welcomemodal', 'SO');
            dataLayer.push({ 'signup_email': emailAddress });
            HSN.DataLayer.helpers.hsnEvent(null, 'EmailPromoSignupModal', 'Success', null, null);
            
            var config = {};
            config.success = function (data) {
                HSN.Instance().GetEmailCaptureModal()._ShowThanks();
            };
            config.error = function () {
                alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
            }

            HSN.Instance().HandleEmailSignup(emailAddress, 55, config);
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });

        $(modal.Content).on('click', '#capture-shop-now', function (e) {
            e.stopPropagation();
            e.preventDefault();
            closeModal(modal);
        });

        $(modal.Content).on('click', '#capture-no-thanks', function (e) {
            e.stopPropagation();
            e.preventDefault();
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        var isThanksView = $('#email-capt-container > .capture-is-thanks-form').val();
        if (!isThanksView) {
            modal.template.HandleNoThanks(null);

            HSN.OnCoremetricsLoad(function() {
                    cmCreateManualLinkClickTag('/email-capture-modal?cm_sp=EmailCapture-_-Modal-_-NoThanks&cm_re=EmailCapture-_-Modal-_-NoThanks', 'EmailCaptureNoThanks');
            });
        }              
        modal.Hide();
    }

    /**
    * HSN.EmailCaptureModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    EmailCaptureModal.prototype._show = function () {
        $.ajax('/account/emailcapture' + '?' + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml(data,
                        0,
                        function () {
                            var elemetToFocus = __scope.Root.find('#modalPopup');  
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 }, function() {
                                __scope.SetFocus(elemetToFocus);
                            });

                            //handle any tooltips loaded
                            if (!Modernizr.touchevents) {
                                HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                            }
                        },
                        function () {
                            //__scope.Center();
                        }
                    );
                    $('input, textarea').placeholder();
                },
                error: function (xhr, status, error) {
                    //Dont think we want to display the loading error if this modal doesnt display?
                    //alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    EmailCaptureModal.prototype._ShowThanks = function () {
        $.ajax('/account/emailcapture/thanks' + '?' + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;

                    this.Content.showHtml
                (
                    data,
                    0,
                    function () {
                        __scope.Center();
                        //handle any tooltips loaded
                        if (!Modernizr.touchevents) {
                            HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                        }
                    },
                    function () {
                        //__scope.Center();
                    }
                );

                },
                error: function (xhr, status, error) {
                    //Dont think we want to display the loading error if this modal doesnt display?
                    //alert("Unfortunately there was an error attempting to load the content, please try again.");
                    HSN.Instance().GetEmailCaptureModal().Hide();
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return EmailCaptureModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/EmailCaptureModal.js